import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AuthGuard from '@/guards/AuthGuard';
import IsAlreadyAuth from '@/guards/isAlreadyAuth';
import RegisterAuth from '@/guards/Attendee/register';
import IsAlreadyRegister from '@/guards/Attendee/isAlreadyRegistered';
import { Suspense } from 'react';
import Fallback from '@/components/Fallback';
import {
	AdminHome,
	IconsTable,
	UshersTable,
	EventsTable,
	EventForm,
	SessionTable,
	FieldsForm,
	EditForm,
	Profile,
	EvenAdminShow,
	SessionView,
	AdminsTable,
	Login,
	UsherHome,
	EventViewForUsher,
	AttendeeRegistration,
	AttendeeHomePage,
	NotFound,
	PartnersTable,
	RegisterHome,
	PartnerDetails,
	SurveyHome,
	QuestionForm,
	SurveyAnswerForm,
	MailsStatus,
} from '@/routers/pages';

const routers = () => (
	<BrowserRouter>
		<Suspense fallback={<Fallback />}>
			<Routes>
				<Route path="/" element={<Navigate to={'/ushers/login'} />} />
				{/* Admin Routes */}
				<Route element={<AuthGuard redirectTo="/admins/login" allowedRoles={['admin', 'root']} />}>
					<Route path="/home" element={<AdminHome />} />
					<Route path="/icons" element={<IconsTable />} />
					<Route path="/ushers" element={<UshersTable />} />
					<Route path="/events" element={<EventsTable />} />
					<Route path="/event-form" element={<EventForm />} />
					<Route path="/event/:eventId/sessions" element={<SessionTable />} />
					<Route path="/event/:eventId/survey" element={<SurveyHome />} />
					<Route path="/event/:eventId/mails-status" element={<MailsStatus />} />
					<Route path="/survey/:surveyId/add-question" element={<QuestionForm />} />
					<Route path="/survey/:surveyId/update-question/:questionId" element={<QuestionForm />} />
					<Route path="/event/:eventId/fields" element={<FieldsForm />} />
					<Route path="/event-form/:eventId" element={<EditForm />} />
					<Route path="/admin-profile" element={<Profile target={'admins'} />} />
					<Route path="/event/show/:eventId" element={<EvenAdminShow />} />
					<Route path="/event/show/:eventId/:sessionId" element={<SessionView navLink="/home" />} />
					<Route path="/partners" element={<PartnersTable />} />
					<Route path="/partner/:partnerId" element={<PartnerDetails />} />
					<Route path="/registers" element={<RegisterHome />} />
				</Route>

				<Route element={<AuthGuard redirectTo="/admins/login" allowedRoles={['root']} />}>
					<Route path="/admins" element={<AdminsTable />} />
				</Route>

				<Route element={<IsAlreadyAuth redirectTo="/home" />}>
					<Route path="/admins/login" element={<Login target="admins" />} />
				</Route>

				{/* Usher Routes */}
				<Route element={<IsAlreadyAuth redirectTo="/usher-home" />}>
					<Route path="/ushers/login" element={<Login target="ushers" />} />
				</Route>
				<Route element={<AuthGuard redirectTo="/ushers/login" allowedRoles={['usher']} />}>
					<Route path="/usher-home" element={<UsherHome />} />
					<Route path="/usher-profile" element={<Profile target={'ushers'} />} />
					<Route path="/event/:eventId/usher-view" element={<EventViewForUsher />} />
					<Route
						path="/event/:eventId/usher-view/:sessionId"
						element={<SessionView navLink="/usher-home" />}
					/>
				</Route>

				{/* Global Routes */}
				<Route element={<IsAlreadyRegister />}>
					<Route path="/events/:eventId/register" element={<AttendeeRegistration />} />
				</Route>

				<Route element={<RegisterAuth />}>
					<Route path="/events/:eventId/qr/:attendeeId" element={<AttendeeHomePage />} />
				</Route>
				<Route path="/survey/:surveyId/:attendeeId" element={<SurveyAnswerForm />} />

				<Route path="*" element={<NotFound message="Page Not Found" reDirectToRoleHome={true} />} />
			</Routes>
		</Suspense>
	</BrowserRouter>
);

export default routers;
